import React__default from 'react';
import classNames from 'classnames';
import Styles from './BaseCard.module.scss.js';

const BaseCard = ({ topSection, bottomSection, id, disabled, baseCardWrapperClassName }) => {
    return (React__default.createElement("div", { className: classNames(Styles.baseCard, disabled ? Styles.baseCard__grey : "", baseCardWrapperClassName), id: id },
        React__default.createElement("div", { className: Styles.topSection }, topSection),
        React__default.createElement("div", { className: Styles.bottomSection }, bottomSection)));
};

export { BaseCard as default };
//# sourceMappingURL=BaseCard.js.map
